import { render } from "./aboutUs.vue?vue&type=template&id=cdbda886&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"

import "./aboutUs.vue?vue&type=style&index=0&id=cdbda886&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbda886"]])

export default __exports__